import React, { useState, useEffect } from "react";
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  Platform,
  TouchableNativeFeedback,
  Image,
  Dimensions,
} from "react-native";
import Colors from "../constants/Colors";
import DefaultTextLight from "./text/DefaultTextLight";
import DefaultText from "./text/DefaultText";
import BouncyCheckbox from "react-native-bouncy-checkbox";

const GridTileThree = (props) => {
  let TouchableCmp = TouchableOpacity;
  const [checkboxState, setCheckboxState] = useState(false);

  const checkboxHandler = () => {
    props.checkOne();
  };

  if (Platform.OS === "android" && Platform.Version >= 21) {
    TouchableCmp = TouchableNativeFeedback;
  }
  if (props.empty === true) {
    return <View style={[styles.gridItem, styles.itemInvisible]} />;
  }
  let thumbnailImg = props.imageUrl;
  if (props.imageUrl.endsWith("mp4") || props.imageUrl.endsWith("svg")) {
    thumbnailImg = props.collectionImageUrl;
  }
  return (
    <View style={styles.gridItem}>
      <TouchableCmp
        style={{ flex: 1, backgroundColor: "black" }}
        onPress={() => {
          if (!props.isCasting) {
            props.onSelect();
          } else {
            checkboxHandler();
          }
          // setCheckboxState(!checkboxState);
        }}
      >
        <View style={styles.imgContainer}>
          <Image style={styles.image} source={{ uri: thumbnailImg }} />
          {props.isCasting ? (
            <BouncyCheckbox
              style={styles.checkbox}
              size={15}
              unfillColor="white"
              fillColor={Colors.accent}
              disableText={true}
              iconStyle={{}}
              isChecked={props.isChecked}
              disableBuiltInState
              onPress={checkboxHandler}
            />
          ) : (
            <View></View>
          )}
        </View>
        <DefaultText style={styles.title} numberOfLines={2}>
          {props.title}
        </DefaultText>
      </TouchableCmp>
    </View>
  );
};

const numColumns = 3;
const maxWidth = 500;
let { height, width } = Dimensions.get("window");
width = width > maxWidth ? maxWidth : width;
const gridMargin = 2;
const gridWidth = Math.floor((width - gridMargin * numColumns) / numColumns);
const gridHeight = gridWidth;
const styles = StyleSheet.create({
  gridItem: {
    flex: 1,
    margin: gridMargin,
    height: Platform.OS === "web" ? gridHeight + 32 : null,
    width: gridWidth,
    // height: gridWidth,
    overflow:
      Platform.OS === "android" && Platform.Version >= 21
        ? "hidden"
        : "visible",
  },
  imgContainer: {
    flex: 1,
    //padding: 15,
    width: gridWidth,
    height: gridHeight,
  },
  title: {
    paddingTop: 6,
    textAlign: "center",
    height: 32,
    fontSize: 12,
  },

  image: {
    width: "100%",
    height: "100%",
  },
  itemInvisible: {
    backgroundColor: "transparent",
  },
  checkbox: {
    position: "absolute",
    bottom: 5,
    left: "45%", //FIXME not always in middle..
  },
});

export default GridTileThree;
